// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".circle[data-v-16fe75fc]{align-items:center;background:var(--colour-light-green);border-radius:99em;display:flex;justify-content:center;left:2.1em;min-height:.75em;min-width:.75em;position:absolute;visibility:visible;z-index:1}.circle i[data-v-16fe75fc]{color:#fff;font-size:.6em;font-style:normal;font-weight:700;padding:0 .35em}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
